import { StatisticsSendStatus } from "../core/api/models";

export class SendStatusTypesUiDto {
    type?:StatisticsSendStatus;
    colorName?:string;
    color?:string;
}

const styles = getComputedStyle(document.documentElement);

export const SendStatusTypesUi : SendStatusTypesUiDto[] = [
    {
        type:StatisticsSendStatus.NotReceivedByItc,
        colorName:"info",
        color:styles.getPropertyValue('--color-info')
    },
    {
        type:StatisticsSendStatus.ReceivedByPhone,
        colorName:"success",
        color:styles.getPropertyValue('--color-success')
    },
    {
        type:StatisticsSendStatus.NotReceiveByPhone,
        colorName:"danger",
        color:styles.getPropertyValue('--color-danger')
    },
    {
        type:StatisticsSendStatus.InvalidPrivateNumber,
        colorName:"warning",
        color:styles.getPropertyValue('--color-warning')
    },
    {
        type:StatisticsSendStatus.SentToItc,
        colorName:"blue",
        color:styles.getPropertyValue('--color-blue')
    },
    {
        type:StatisticsSendStatus.BlackList,
        colorName:"slate",
        color:styles.getPropertyValue('--color-slate')
    },  
];